define(["require", "exports", "jquery", "knockout", "../../utils/kendoUtils", "../../utils/tools", "../../models/UserContext", "../../models/CustomerEmployeeModel", "../../utils/LookupDataSources"], function (require, exports, $, ko, KendoUtils, tools, UserContext, CustomerEmployeeModel, LookupDataSources) {
    "use strict";
    var CustomerEmployees = /** @class */ (function () {
        function CustomerEmployees(customerId, initCallback) {
            this.userCanViewEmployees = ko.observable(UserContext.hasAccess("Admin,CustomerEmployee.View,CustomerEmployee.Edit,CustomerEmployee.Delete"));
            this.userCanEditEmployees = ko.observable(UserContext.hasAccess("Admin,CustomerEmployee.Edit,CustomerEmployee.Delete"));
            this.userCanDeleteEmployees = ko.observable(UserContext.hasAccess("Admin,CustomerEmployee.Delete"));
            this.customerId = ko.observable(0);
            this.editModel = ko.observable(new CustomerEmployeeModel());
            var self = this;
            self.customerId(customerId);
            if (self.userCanViewEmployees()) {
                // Get lookup data:
                var getLookupData = tools.ajaxGet({
                    url: "/CustomerEmployees/GetEmployeesLookupData",
                    success: function (data) {
                        if (data.Success) {
                            self.lookupLists = data.Data.lookupLists;
                            self.employeesGridStructure = self.lookupLists.GridStructures.CustomerEmployeesStructure;
                        }
                    }
                });
                $.when(getLookupData).done(function () {
                    self.initExportDataSource();
                    if (initCallback) {
                        initCallback(self);
                    }
                });
            }
        }
        CustomerEmployees.prototype.initGrid = function () {
            var self = this;
            if (self.userCanViewEmployees()) {
                self.initCustomerEmployees();
            }
        };
        CustomerEmployees.prototype.initExportDataSource = function () {
            var self = this;
            self.customerEmployeesDataSourceOptions = {
                transport: {
                    read: {
                        url: "/CustomerEmployees/GetCustomerEmployees",
                        type: "POST",
                        data: function () {
                            var data = {};
                            data.id = self.customerId();
                            return data;
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                }
            };
            self.customerEmployeesDataSource = new kendo.data.DataSource(self.customerEmployeesDataSourceOptions);
        };
        CustomerEmployees.prototype.initCustomerEmployees = function () {
            var self = this;
            var gridId = "divCustomerEmployeeTable";
            var columns = self.employeesGridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function () {
                    var html = "";
                    if (self.userCanEditEmployees()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDeleteEmployees()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            });
            self.customerEmployeesTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerEmployees/GetCustomerEmployees?id=" + self.customerId(),
                            type: "POST",
                            data: function () {
                                var data = {};
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverSorting: false
                },
                gridOptions: {
                    pageable: true,
                    columns: columns,
                    resizable: true
                },
                enableExport: {
                    entityName: "CustomerEmployee",
                    title: "Customer Members",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                gridId: gridId,
                showPagerOnTop: false
            };
            self.customerEmployeesTable.initGrid(gridOptions);
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.editCustomerEmployee(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.deleteEmployeeConfirm(data);
                event.preventDefault();
            });
        };
        CustomerEmployees.prototype.editCustomerEmployee = function (id) {
            var self = this;
            var title = $.isNumeric(id) ? "Edit Member" : "Add Member";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    self.editModel().EmployeeId(self.employeesDropdown.value());
                    self.editModel().EmployeeRoleId(self.employeeRolesDropdown.value());
                    self.editModel().CommissionRoleId(self.commissionRolesDropdown.value());
                    //validate form
                    if (!self.editModel().CustomerId()) {
                        tools.error("Customer is a required field");
                        return;
                    }
                    if (!self.editModel().EmployeeId()) {
                        tools.error("Member is a required field");
                        return;
                    }
                    if (!self.editModel().EmployeeRoleId()) {
                        tools.error("Position is a required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCustomerExternalUser(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CustomerEmployees/GetCustomerEmployeeById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new CustomerEmployeeModel(result.Data));
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new CustomerEmployeeModel());
                        self.editModel().CustomerId(self.customerId());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customer-employee-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        var lookupDataSources = new LookupDataSources();
                        var employeesDS = lookupDataSources.createLookupDataSource("Employees");
                        var employeeRolesDS = lookupDataSources.createLookupDataSource("EmployeeRoles");
                        var commissionRolesDS = lookupDataSources.createLookupDataSource("EmployeeCommissionRoles");
                        self.employeesDropdown = $("input[name=EmployeeId]", modal).kendoDropDownList({
                            dataSource: employeesDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            popup: {
                                appendTo: $(".modal-body", modal)
                            }
                        }).data("kendoDropDownList");
                        if (self.employeesDropdown) {
                            self.employeesDropdown.value(self.editModel().EmployeeId());
                        }
                        self.employeeRolesDropdown = $("input[name=EmployeeRoleId]", modal).kendoDropDownList({
                            dataSource: employeeRolesDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            popup: {
                                appendTo: $(".modal-body", modal)
                            }
                        }).data("kendoDropDownList");
                        if (self.employeeRolesDropdown) {
                            self.employeeRolesDropdown.value(self.editModel().EmployeeRoleId());
                        }
                        self.commissionRolesDropdown = $("input[name=CommissionRoleId]", modal).kendoDropDownList({
                            dataSource: commissionRolesDS,
                            cascadeFrom: "EmployeeId",
                            cascadeFromField: "EmployeeId",
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            optionLabel: "Select Commissions Role",
                            filter: "contains",
                            popup: {
                                appendTo: $(".modal-body", modal)
                            }
                        }).data("kendoDropDownList");
                        if (self.commissionRolesDropdown) {
                            self.commissionRolesDropdown.value(self.editModel().CommissionRoleId());
                        }
                    });
                }
            });
        };
        CustomerEmployees.prototype.addNewEmployee = function () {
            var self = this;
            if (self.userCanEditEmployees()) {
                self.editCustomerEmployee();
            }
        };
        CustomerEmployees.prototype.saveCustomerExternalUser = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerEmployees/SaveCustomerEmployee",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.customerEmployeesTable.refresh();
                    $(modal).modal("hide");
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerEmployees.prototype.deleteEmployeeConfirm = function (user) {
            var self = this;
            tools.confirmModal({
                title: "Delete Customer Member",
                text: "Are you sure you want to delete Customer Member?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCustomerEmployee(user.Id);
            });
        };
        CustomerEmployees.prototype.deleteCustomerEmployee = function (employeeId) {
            var self = this;
            var data = {
                id: employeeId
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerEmployees/DeleteCustomerEmployeeConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Customer member deleted successfully");
                    self.customerEmployeesTable.refresh();
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        return CustomerEmployees;
    }());
    return CustomerEmployees;
});
//# sourceMappingURL=customerEmployees.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerEmployees.js
// module id = 168
// module chunks = 2